var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeart = function SvgHeart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "m3.08 11.257 6 5.394c.25.224.578.349.92.349s.67-.125.92-.349l6-5.394a4.7 4.7 0 0 0 1.58-3.5V7.57c0-2.235-1.677-4.141-3.964-4.509a4.86 4.86 0 0 0-4.138 1.276L10 4.722l-.398-.384a4.86 4.86 0 0 0-4.138-1.276C3.177 3.43 1.5 5.336 1.5 7.571v.185c0 1.327.571 2.596 1.58 3.501"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
export default ForwardRef;